<template>
  <div class="articleDetail">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/News' }">政策解读</el-breadcrumb-item>
      <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="article-title">{{article.title}}</div>
    <div style="width: 1106px;margin: 0 auto;height:40px;">
      <span
        v-if="article.source"
        style="float:left;"
      >来源：{{article.source}}</span>
      <span style="float:right;">{{article.time |FormatTime}}</span>
    </div>
    <div  style="width: 1106px;margin: 0 auto;">
      <div
      v-html="article.content"
    >
    </div>
    </div>
  </div>
</template>
<script>
import { getNewsDetail } from "@/api";
export default {
  name: "articleDetail",
  data () {
    return {
      title: "",
      updateTime: "",
      publisher: "",
      article: {},
      detail: "新闻详情",
    };
  },
  async mounted () {
    console.log(this.$route.params.id)
    let data = await getNewsDetail({ id: this.$route.params.id });
    this.article = data.data;


  },
};
</script>
<style scoped>
.articleDetail {
  padding: 20px 180px;
  min-height:420px;
  background-color: #fff;
}
.article-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin: 30px;
}
</style>
